import { Grid, Tab, Tabs, styled } from "@mui/material";

import PortfolioChartBox from "./Components/PortfolioChartBox";
import PortfolioChartDebit from "./Components/PortfolioChartDebit";
import { getPortfolioChartForm } from "store/slices/portfolio/portfolioSlice";
import useDispatch from "hooks/useDispatch";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMemo } from "react";

function PortfolioCard() {
  const dispatch = useDispatch();
  const portfolioChartForm = useSelector((state) => state.portfolio?.portfolioChartForm?.data);
  const defaultPortfolioChartForm = useMemo(() => portfolioChartForm?.lisPortfolioChartFormDetail?.find((l) => l?.id === portfolioChartForm?.portfolioChartFormDetailId), [portfolioChartForm])

  const [searchParams, setSearchParams] = useSearchParams();

  const portfolioTab = +searchParams.get("portfolioTab") || defaultPortfolioChartForm?.portfolioId || 1;
  const basketTab = +searchParams.get("basketTab") || 0;

  const handleChangePortfolio = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      portfolioTab: newValue,
    });
  };

  const handleChangeBasket = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      basketTab: newValue,
    });
  };

  const portfolios = useMemo(() => portfolioChartForm?.lisPortfolioChartFormDetail?.filter(p => !p?.basketId), [portfolioChartForm])
  const allBaskets = useMemo(() => portfolioChartForm?.lisPortfolioChartFormDetail?.filter(p => !!p?.basketId), [portfolioChartForm])

  const currentPortfolioBaskets = useMemo(() => {
    const basketList = allBaskets?.filter((p) => p?.portfolioId === portfolioTab)
    const firstBasketList = basketList?.[0]?.basketId || 0

    handleChangeBasket(null, firstBasketList)

    return basketList

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolioTab, allBaskets])

  useEffect(() => {
    dispatch(getPortfolioChartForm());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TabsStyle value={portfolioTab} onChange={handleChangePortfolio}>
          {portfolios?.map((type) => (
            <Tab label={type.name} value={type.portfolioId} />
          ))}
        </TabsStyle>
      </Grid>

      <Grid item xs={12}>
        <TabsStyle value={basketTab} onChange={handleChangeBasket}>
          <Tab label={"All"} value={0} />

          {currentPortfolioBaskets?.map((type) => (
            <Tab label={type.name} value={type.basketId} />
          ))}
        </TabsStyle>
      </Grid>

      <Grid item xs={12}>
        <PortfolioChartBox />

        <PortfolioChartDebit />
      </Grid>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiTabs-flexContainer": {
    maxWidth: "300px",
    margin: "auto",
    justifyContent: "space-between",

    [theme.breakpoints.down('md')]: {
      maxWidth: '400px',
      justifyContent: "center",
      gap: theme.spacing(1),
    }
  },
}));

export default PortfolioCard;
